import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { LayoutCreateDto, LayoutDto, LayoutRoleDto, LayoutUpdateDto, SetFavoriteLayoutDto } from '../dtos/layout/models';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  apiName = 'AdministrationService';
  

  create = (input: LayoutCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, LayoutDto>({
      method: 'POST',
      url: '/api/administration/layouts',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/administration/layouts/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getBasic = (entityName: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, LayoutDto>({
      method: 'GET',
      url: '/api/administration/layouts/basic',
      params: { entityName },
    },
    { apiName: this.apiName,...config });
  

  getList = (entityName: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, LayoutDto[]>({
      method: 'GET',
      url: '/api/administration/layouts',
      params: { entityName },
    },
    { apiName: this.apiName,...config });
  

  getRolesByPermissionName = (permissionName: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, LayoutRoleDto[]>({
      method: 'GET',
      url: '/api/administration/layouts/roles',
      params: { permissionName },
    },
    { apiName: this.apiName,...config });
  

  setFavorite = (input: SetFavoriteLayoutDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/administration/layouts/set-favorite',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: LayoutUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, LayoutDto>({
      method: 'PUT',
      url: `/api/administration/layouts/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
